var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[
    'button',
    {
      'button--has-radius': _vm.hasRadius,
      'button--fluid': _vm.isFluid,
      'button--active': _vm.isActive,
      'button--clear': _vm.isClear,
      'button--disabled': _vm.isDisabled,
    } ],on:{"click":function($event){return _vm.$emit('action')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }